import { FormikProps, useField } from 'formik'
import * as React from 'react'

import { ErrorMessage } from '../register/styles'
import { StyledTextInput } from '../styles'

// @ts-ignore
// eslint-disable-next-line
export type FormInputProps = FormikProps<any> &
  React.InputHTMLAttributes<HTMLInputElement> & {
    name: string
    errorMessageId?: string
  } & React.RefAttributes<HTMLInputElement>

export const FormInput = ({
  errorMessageId,
  handleBlur,
  handleChange,
  required = false,
  ref,
  ...props
}: FormInputProps) => {
  const [fields, meta] = useField(props)
  const hasError = meta.touched && meta.error
  return (
    <>
      <StyledTextInput
        aria-describedby={errorMessageId}
        aria-invalid={!!hasError}
        aria-required={required}
        data-testid={`${fields.name}`}
        hasError={hasError}
        onBlur={handleBlur}
        onChange={handleChange}
        ref={ref}
        value={fields.value}
        {...props}
      />
      {hasError ? (
        <ErrorMessage id={errorMessageId} data-testid={`${fields.name}-error`}>
          {meta.error}
        </ErrorMessage>
      ) : null}
    </>
  )
}
